<template>
    <div class="card mb-0 shadow">
        <div class="card-body p-2" style="height: calc(100vh - 130px)">
            <ChatBox mode="page" />
        </div>
    </div>
</template>

<script>
import ChatBox from "@/dashboard/components/widgets/chat/ChatBox";

export default {
    components: {
        ChatBox,
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
